import { BrowserProductQueryQuery } from "@generated/graphql"
import { ProductType } from "src/components/product/ProductCard/ProductCardTypes"
import { ProductKitLookAndBrowserQuery } from "src/components/product/ProductKitLook/ProductKitLookDetails"

export const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1)

export const getCategorie = (
  itemListElement: Array<{ name?: string }>,
  productName: string
): string[] => {
  if (!Array.isArray(itemListElement) || itemListElement.length < 2) {
    return []
  }

  const listWithoutProduct = itemListElement.slice(0, -1)

  const startIndex = listWithoutProduct?.findIndex((element) => {
    const name = element.name?.trim().toLowerCase()
    return name === 'life' || name === 'vivara'
  })

  if (startIndex === -1) {
    return []
  }

  const relevantItems = listWithoutProduct?.slice(startIndex)

  const categories = relevantItems
    .map((element) => element.name?.trim() || '')
    .filter(
      (name) =>
        name.toLowerCase() !== 'sem pedra' &&
        name !== '' &&
        name !== productName?.trim()
    )

  return categories
}

export const getItemSizeFromProperties = (
  variantProps: any[] = [],
  additionalProps: any[] = []
): string => {
  const sizeKeys = ['tamanho', 'aro']
  const secondaryKeys = ['altura aprox', 'largura aprox', 'comprimento aprox']
  const sizeParts: string[] = []

  for (const key of sizeKeys) {
    const match = additionalProps?.find((p) =>
      p.name?.toLowerCase()?.includes(key)
    )

    if (match && match.value) {
      sizeParts.push(`${capitalize(match.name)}: ${match.value}`)
      break
    }
  }

  for (const key of secondaryKeys) {
    const match = variantProps?.find((p) => p.name?.toLowerCase().includes(key))

    if (match && match.value) {
      sizeParts.push(`${capitalize(match.name)}: ${match.value}`)
    }
  }

  return sizeParts.join(' / ')
}

export const getVariantWithSmallestSize = (product: ProductType | ProductKitLookAndBrowserQuery) => {
  const variants = product?.isVariantOf?.hasVariant

  if (!Array.isArray(variants)) {
    return product
  }

  const variantsWithSizeAndStock = variants.map((variant) => {
    const availability = variant?.offers?.offers?.[0]?.availability
    const inStock = availability === 'https://schema.org/InStock'

    if (!inStock) {
      return null
    }

    const sizeProp = variant?.additionalProperty?.find((prop) =>
      ['aro', 'tamanho'].includes(prop.name?.toLowerCase())
    )

    if (!sizeProp) {
      return null
    }

    const sizeValue = parseFloat(sizeProp.value as string)

    if (isNaN(sizeValue)) {
      return null
    }

    return {
      variant,
      sizeValue,
    }
  })?.filter(Boolean)

  if (variantsWithSizeAndStock?.length === 0) {
    return product
  }

  variantsWithSizeAndStock?.sort(
    (a, b) => a?.sizeValue - b?.sizeValue
  )

  return variantsWithSizeAndStock?.[0]?.variant
}

export const getProperty = (product: BrowserProductQueryQuery['product'], name: string) =>
  String(
    product?.isVariantOf?.additionalProperty?.find(
      (p) => p?.name?.toLowerCase() === name.toLowerCase()
    )?.value ?? ''
  )
